export const ExternalServiceType = Object.freeze({
  RMS: 'RMS',
  TBB: 'TBB',
})
